import { useEffect, useState } from 'react';

export const useScreenSize = (callback?: (props: { height: number; width: number }) => void) => {
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
      callback?.({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [callback]);

  const isMobile = screenSize.width <= 1023;

  return {
    ...screenSize,
    isMobile,
    scrollableTarget: isMobile ? 'mobile-scrollbar-target' : 'scrollbar-target',
  };
};
